<template>
  <CRow>

    <CCol sm="12">
      <CCard>

        <CCardHeader>
          <CIcon name="cil-lan" />
          <h5 class="d-inline ml-2">Hubs</h5>
          <div class="card-header-actions">
            <CButton color="primary" :to="{ name: 'Add New Hub'}">
              <CIcon name="cil-plus" class="align-bottom" /><strong>Add New</strong> Hub
            </CButton>
          </div>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "Hubs",
  components: {
    BackendTable,
  },
};
</script>
